import {
  BORDER_RADIUS,
  COLORS,
  DEFAULT_TRANSITION_ALL,
  BREAKPOINT,
} from "utils/styles";
import { FeedDispatchContext, FeedStateContext } from "context/feed";
import { POST_TYPES, TOPICS } from "posts/constants";
import React, { useContext, useState } from "react";
import { Dropdown } from "react-bootstrap";

import {
  Button,
  Accordion,
  useAccordionToggle,
  AccordionContext,
  OverlayTrigger,
  Overlay,
} from "react-bootstrap";
import FilterItem from "./FilterItem";
import get from "lodash.get";
import styled from "styled-components";
import { SMALL_SCREEN_BREAKPOINT } from "components/Nav/Nav";

const BREAKPOINT_LARGE = "1024px";

const Wrapper = styled.div.attrs({ className: "d-none d-sm-block" })``;

const InnerWrapper = styled.div`
  ${BORDER_RADIUS};
  background: ${COLORS.WHITE};
  font-size: 0.875rem;
  padding: 1em;

  width: 255px;
  z-index: 100;

  @media (max-width: ${BREAKPOINT_LARGE}) {
    max-width: 600px;
    width: calc(100% - 2rem);
    position: fixed;
  }
`;

const StyledToggle = styled.span.attrs({ className: "mabry-regular" })`
  cursor: pointer;
  display: flex;
  margin-bottom: 1em;
`;

const DropdownToggle = styled(Button)`
  span {
    font-family: "mabry-regular", sans-serif;
    font-weight: 400;
  }

  i {
    display: inline-block;
    margin-left: 0.5rem;
    transform: translateY(4px);
  }
  &::after {
    display: none;
  }
`;

function Toggle({ children, eventKey, callback }) {
  const currentEventKey = useContext(AccordionContext);
  const decoratedOnClick = useAccordionToggle(
    eventKey,
    () => callback && callback(eventKey)
  );
  const isExpanded = currentEventKey === eventKey;

  return (
    <StyledToggle isExpanded={isExpanded} onClick={decoratedOnClick}>
      {children}
      <Icon className="material-icons-round md-18 pl-2">
        {isExpanded ? "keyboard_arrow_up" : "keyboard_arrow_down"}
      </Icon>
    </StyledToggle>
  );
}

const SectionWrapper = styled.div`
  margin-bottom: 1em;
`;

const ToggleLabel = styled.span`
  display: block;
  flex-grow: 1;
`;

const Icon = styled.i`
  display: block;
  margin-right: 6px;
  width: 24px;
  transform: translateY(2px);
`;

export default function FeedFilters() {
  const { filters } = useContext(FeedStateContext);
  const feedDispatch = useContext(FeedDispatchContext);

  const handleFilterChange = (path, value) => {
    feedDispatch({
      type: "set-filter",
      payload: {
        path,
        value,
      },
    });
  };

  const renderSortingOptions = () => {
    return (
      <Accordion defaultActiveKey="0">
        <Accordion.Toggle as={Toggle} eventKey="0">
          Sorting
        </Accordion.Toggle>
        <Accordion.Collapse eventKey="0">
          <SectionWrapper>
            <FilterItem
              icon="poll"
              title="Article"
              isActive={get(filters, ["sorting", POST_TYPES.ARTICLE])}
              path={`postTypes.${POST_TYPES.ARTICLE}`}
              onChange={handleFilterChange}
            />
          </SectionWrapper>
        </Accordion.Collapse>
      </Accordion>
    );
  };

  const renderMediaTypeFilters = () => {
    return (
      <Accordion defaultActiveKey="">
        <Toggle eventKey="0">
          <Icon className="material-icons-round md-18">volume_up</Icon>
          <ToggleLabel>Media Types</ToggleLabel>
        </Toggle>
        <Accordion.Collapse eventKey="0">
          <SectionWrapper>
            <FilterItem
              title="Article"
              isActive={get(filters, ["postTypes", POST_TYPES.ARTICLE])}
              path={`postTypes.${POST_TYPES.ARTICLE}`}
              onChange={handleFilterChange}
            />
            <FilterItem
              title="Photo"
              isActive={get(filters, ["postTypes", POST_TYPES.PHOTO])}
              path={`postTypes.${POST_TYPES.PHOTO}`}
              onChange={handleFilterChange}
            />
            <FilterItem
              title="Music"
              isActive={get(filters, ["postTypes", POST_TYPES.MUSIC])}
              path={`postTypes.${POST_TYPES.MUSIC}`}
              onChange={handleFilterChange}
            />
            <FilterItem
              title="Twitter"
              isActive={get(filters, ["postTypes", POST_TYPES.TWITTER])}
              path={`postTypes.${POST_TYPES.TWITTER}`}
              onChange={handleFilterChange}
            />
            <FilterItem
              title="Television"
              isActive={get(filters, ["postTypes", POST_TYPES.TV])}
              path={`postTypes.${POST_TYPES.TV}`}
              onChange={handleFilterChange}
            />
            <FilterItem
              title="Video"
              isActive={get(filters, ["postTypes", POST_TYPES.VIDEO])}
              path={`postTypes.${POST_TYPES.VIDEO}`}
              onChange={handleFilterChange}
            />
          </SectionWrapper>
        </Accordion.Collapse>
      </Accordion>
    );
  };

  const renderTopicFilters = () => {
    return (
      <Accordion defaultActiveKey="">
        <Toggle eventKey="0">
          <Icon className="material-icons-round md-18">forum</Icon>
          <ToggleLabel>Topics</ToggleLabel>
        </Toggle>
        <Accordion.Collapse eventKey="0">
          <SectionWrapper>
            <FilterItem
              title="Poverty"
              isActive={get(filters, ["topics", TOPICS.POVERTY])}
              path={`topics.${TOPICS.POVERTY}`}
              onChange={handleFilterChange}
            />
            <FilterItem
              title="COVID"
              isActive={get(filters, ["topics", TOPICS.COVID])}
              path={`topics.${TOPICS.COVID}`}
              onChange={handleFilterChange}
            />
            <FilterItem
              title="Black Lives Matter"
              isActive={get(filters, ["topics", TOPICS.BLM])}
              path={`topics.${TOPICS.BLM}`}
              onChange={handleFilterChange}
            />
          </SectionWrapper>
        </Accordion.Collapse>
      </Accordion>
    );
  };

  return (
    <Wrapper>
      <Dropdown>
        <Dropdown.Toggle as={DropdownToggle} variant="white">
          <span>Filters</span>{" "}
          <i className="material-icons-round md-dark md-18">filter_list</i>
        </Dropdown.Toggle>
        <Dropdown.Menu>
          <InnerWrapper>
            <FilterItem
              icon="category"
              title="Narratives Only"
              isActive={get(filters, ["narratives", "narrativesOnly"])}
              path="narratives.narrativesOnly"
              onChange={handleFilterChange}
            />
            {renderMediaTypeFilters()}
            {renderTopicFilters()}
          </InnerWrapper>
        </Dropdown.Menu>
      </Dropdown>
    </Wrapper>
  );
}
